var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{ selected: _vm.selected },on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":_vm.url,"alt":_vm.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }